import {
  GameDayInfo,
  MatchGroup,
  MatchInfosForScoreSheets,
} from '@/modules/league/new-components/types';

interface PrintFormProps {
  sheetSize: string;
  matchGroups: MatchGroup[];
  headerContent: GameDayInfo;
  innerRef: React.RefObject<HTMLDivElement>;
  poolsData: Record<string, MatchInfosForScoreSheets[]>;
}

export const PrintForm = ({
  headerContent,
  matchGroups,
  innerRef,
  sheetSize,
  poolsData,
}: PrintFormProps) => {
  const { details } = headerContent;

  return (
    <div ref={innerRef} className='m-0 hidden p-0 print:block'>
      {/* Iterate over poolsData to display each PoolID's matches */}
      {Object.entries(poolsData).map(([poolId, matches]) => (
        <div key={poolId} className='break-after-page p-2'>
          {matches.map((match, index) => (
            <div
              key={`match-score-sheet-${index}`}
              className={`flex flex-col px-7 pt-2 ${sheetSize === 'Full Sheets' ? 'print-full-sheet' : 'print-half-sheet'}`}
            >
              <div className='mt-4 w-full border-t-4 border-dashed border-gray-900 px-2' />
              <div className='flex flex-col gap-2 p-2'>
                <p className='font-bold tracking-wider'>
                  {`Group ${matchGroups.find((group) => group.PoolID === match.PoolID)?.PoolNumber || 'Unknown'} : Match ${match.DisplayMatchNumber}`}
                </p>
                <p>Court: </p>
                <p className='font-bold tracking-wider'>{details.leagueTitle}</p>
                <div className='flex w-full flex-col justify-between text-center'>
                  <div className='flex w-full flex-row justify-between text-center'>
                    <div className='flex flex-col justify-between gap-2 text-left'>
                      <p className='font-bold tracking-wider'>{match.Shorthand}</p>

                      <p className='line-clamp-3'>
                        {`${match.T1a_FirstName} ${match.T1a_LastName} / ${match.T1b_FirstName} ${match.T1b_LastName}`}
                      </p>

                      <p className='line-clamp-3'>
                        {`${match.T2a_FirstName} ${match.T2a_LastName} / ${match.T2b_FirstName} ${match.T2b_LastName}`}
                      </p>
                    </div>
                    <div className='flex flex-col items-center justify-between gap-2'>
                      <div className='flex flex-row items-center gap-10'>
                        {Array.from({ length: match.MaxGames || 0 }, (_, i) => (
                          <div key={`g-${i + 1}`}>{`G:${i + 1}`}</div>
                        ))}
                      </div>
                      <div className='flex flex-col gap-1'>
                        <div className='flex flex-row items-center gap-2'>
                          {Array.from({ length: match.MaxGames || 0 }, (_, i) => (
                            <div
                              key={`t1-g-${i}`}
                              className='flex h-9 w-14 items-center justify-center rounded-md border !border-gray-900 font-bold !text-gray-900'
                            />
                          ))}
                        </div>
                        <div className='flex flex-row items-center gap-2'>
                          {Array.from({ length: match.MaxGames || 0 }, (_, i) => (
                            <div
                              key={`t2-g-${i}`}
                              className='flex h-9 w-14 items-center justify-center rounded-md border !border-gray-900 font-bold !text-gray-900'
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className='flex flex-col items-center gap-2'>
                      <p>Initials</p>
                      <div className='flex flex-col gap-1'>
                        <div className='flex h-9 w-14 items-center justify-center rounded-md border border-gray-900 font-bold text-gray-900' />
                        <div className='flex h-9 w-14 items-center justify-center rounded-md border border-gray-900 font-bold text-gray-900' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='w-full border-t-4 border-gray-900 px-2' />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
